import { CONFIRMATION_REQUIRED_REASON, type SignInCodeChannel } from '@chukua/common';
import { ApiError } from '../../../shared/shared.api';
import { localMobile } from '../../../shared/policies/local-mobile';

/** The server's answer to a sensitive change made before the session was confirmed: ask for a code, then try again. */
export function isConfirmationRequired(err: unknown): boolean {
  if (!(err instanceof ApiError) || err.status !== 403) return false;
  const body = err.body as { reason?: unknown } | undefined;
  return body?.reason === CONFIRMATION_REQUIRED_REASON;
}

const PHONE_CHANNEL_NAMES: Record<Exclude<SignInCodeChannel, 'email'>, string> = { whatsapp: 'WhatsApp', sms: 'SMS' };

/** Where the confirmation code went, as the sentence says it: "to a@chukua.app" or "by WhatsApp to 0712 345 678". */
export function confirmationDestination(channel: SignInCodeChannel, contact: { email: string; phone: string | null }): string {
  if (channel === 'email') return `to ${contact.email}`;
  const phone = contact.phone ? localMobile(contact.phone) : 'your mobile';
  return `by ${PHONE_CHANNEL_NAMES[channel]} to ${phone}`;
}
